/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import OptionsAdvSetup from '@/assets/icons/help/OptionsAdvSetup.svg';
import OptionsBEContinuous from '@/assets/icons/help/OptionsBEContinuous.svg';
// import OptionsBEDiscrete from '@/assets/icons/help/OptionsBEDiscrete.svg';
import OptionsConcentrate from '@/assets/icons/help/OptionsConcentrate.svg';
import OptionsConcentrate50 from '@/assets/icons/help/OptionsConcentrate50.svg';
import OptionsManualControl from '@/assets/icons/help/OptionsManualControl.svg';
import OptionsRecovery from '@/assets/icons/help/OptionsRecovery.svg';
import OptionsStatusGraph from '@/assets/icons/help/OptionsStatusGraph.svg';
import * as APPDATA from '@/constants/pcConstAppData';

import './AutoProfileHelp.scss';

@connect((store) => ({
  modeHelp: store.setupStore.modeHelp,
}))
class AutoProfileHelpOption extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pcState: undefined,
    };
  }

  // new method to hide & show data
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentState !== prevState.pcState) {
      return {
        pcState: nextProps.currentState,
      };
    }

    // No state update necessary
    return null;
  }

  onClick = (e) => {
    const {dispatch} = this.props;
    dispatch(setupActions.updateMessageAutoProfileHelpParam(e.currentTarget.id));
  };

  render() {
    return (
      <div className="pageHelp">
        <div className="">Tap one of the options available to get the detailed information.</div>
        <div className="helpButton">
          <button
            type="button"
            id={APPDATA.CONCENTRATE_HELP}
            className="ConcentrateButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsConcentrate}
              alt={OptionsConcentrate}
            />
          </button>
          <button
            type="button"
            id={APPDATA.CONCENTRATE50ML_HELP}
            className="Concentrate50mlButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsConcentrate50}
              alt={OptionsConcentrate50}
            />
          </button>

          <button
            type="button"
            id={APPDATA.BUFFER_CONTINOUS_HELP}
            className="BufferContinousButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsBEContinuous}
              alt={OptionsBEContinuous}
            />
          </button>
          <button
            type="button"
            id={APPDATA.ADVANCED_SETUP_HELP}
            className="AdvSetupButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsAdvSetup}
              alt={OptionsAdvSetup}
            />
          </button>
          <button
            type="button"
            id={APPDATA.STATUS_GRAPH_HELP}
            className="StatusGraphButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsStatusGraph}
              alt={OptionsStatusGraph}
            />
          </button>
          <button
            type="button"
            id={APPDATA.MANUAL_CONTROL_HELP}
            className="ManualControlButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsManualControl}
              alt={OptionsManualControl}
            />
          </button>
          <button
            type="button"
            id={APPDATA.RECOVERY_HELP}
            className="RecoveryButton"
            onClick={this.onClick}
          >
            <img
              src={OptionsRecovery}
              alt={OptionsRecovery}
            />
          </button>
        </div>
      </div>
    );
  }
}
export default AutoProfileHelpOption;
